import axios from 'axios'

export default {
  ge: axios.create({
    baseURL: process.env.VUE_APP_BASE_URL.replace('/slim/', '/grid/'),
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json'
    }
  }),
  sg: axios.create({
    baseURL: process.env.VUE_APP_BASE_URL.replace('/slim/', '/grid/').replace('https://capico', 'https://sg.capico').replace('https://titan', 'https://sgtitan'),
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json'
    }
  }),
  get: axios.create({
    baseURL: process.env.VUE_APP_BASE_URL.replace('/slim/', '/grid/').replace('https://capico', 'https://get.capico').replace('https://titan', 'https://gettitan'),
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
//
// export default axios.create({
//   baseURL: process.env.VUE_APP_BASE_URL,
//   withCredentials: true,
//   headers: {
//     'Content-Type': 'application/json'
//   }
// })
